<template>
  <div class="student-dorm">
    <!-- 操作栏容器 -->
    <div class="student-info-operation-container">
      <el-button style="margin: 10px 0 0 30px" @click="$router.back()" size="small">返回</el-button>
      <div class="dorm-info">
        {{ dormInfo.blockName }} - {{ dormInfo.dormName }} -
        {{ dormInfo.dormType }}人间 - 已入住{{ studentListByDormNum }}人
        <!-- <el-button style="margin: 10px 0 0 5px" size="small" @click="movedStudentListShow = true">查看</el-button> -->
      </div>
      <!-- 搜索框 -->
      <div class="student-info-search-container">
        <!-- <search class="student-search" :placeholder="placeholder" @search="search" /> -->
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="student-info-table-container">
      <el-card class="box-card-o">
        <div class="header">
          <h1>未添加的宿舍学生</h1>
          <div class="header-list">
            <!-- 搜索框 -->
            <div class="student-info-search-container">
              <search class="student-search" :placeholder="placeholder" @search="search" />
            </div>
            <!-- 性别 -->
            <div class="select">
              <el-select v-model="sex" placeholder="选择性别" @change="getStudentList" clearable>
                <el-option :label="item.label" :value="item.label" v-for="(item, index) in sexList"
                  :key="index"></el-option>
              </el-select>
            </div>
            <!-- 年级 -->
            <div class="select">
              <el-select v-model="gradeId" placeholder="选择年级" @change="gradeChange" clearable>
                <el-option :label="item.gradeName" :value="item.gradeId" v-for="(item, index) in gradeList"
                  :key="index"></el-option>
              </el-select>
            </div>
            <!-- 班级 -->
            <div class="select">
              <el-select v-model="classId" placeholder="选择班级" @change="classChange" clearable>
                <div slot="empty" style="
                padding: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #c0c4cc;
              ">
                  <div>未选择年级</div>
                </div>
                <el-option :label="item.className" :value="item.classId" v-for="(item, index) in classList"
                  :key="index">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="table">
          <studentList ref="studentList" class="student-list" :studentData="studentData"
            @addStudentDorm="addStudentDorm" />
        </div>
        <!-- 分页容器 -->
        <div class="student-info-pagination-catainer">
          <pagination :pageSize="parseInt(pageInfo.pageSize)" @currentPageNumChange="currentPageNumChange"
            @handleSizeChange="handleSizeChange" :total="parseInt(total)" />
        </div>
      </el-card>
      <el-card class="box-card-t">
        <h1>已添加的宿舍学生</h1>
        <!-- 已入住学生-列表 -->
        <movedStudentList :movedStudentListShow.sync="movedStudentListShow" :studentListByDorm="studentListByDorm"
          @retreat="retreat" />
        <el-button type="primary" @click="$router.back()">完成</el-button>
      </el-card>
    </div>
  </div>
</template>

<script>
// 搜索框
import search from "@/components/search/search.vue";
import studentList from "./nomoved-studentlist/nomoved-studentlist.vue";
import movedStudentList from "./moved-student-list/movedStudentList.vue";
export default {
  data() {
    return {
      dormInfo: null,
      placeholder: "请输入学生名",
      queryName: "",
      studentData: [], // 未入住学生列表
      studentListByDorm: [], // 宿舍已入住学生列表
      studentListByDormNum: 0,
      movedStudentListShow: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
      gradeList: [],
      classList: [],
      gradeId: "",
      classId: "",
      sex: "",
      sexList: [{
        label: "男",
      },
      {
        label: "女",
      }]
    };
  },
  components: {
    search,
    studentList,
    movedStudentList,
  },
  created() {
    if (this.$route.query) {
      this.dormInfo = this.$route.query;
      // console.log("this.dormInfo==>", this.dormInfo);
      this.refresh();
      this.getGradeList();
    }
  },
  methods: {
    // 获取年级
    getGradeList() {
      this.get(this.$url.getgradeList, {
        schoolId: this.school.id,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.gradeList = res.data;
          } else {
            return this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          // console.log(err)
          // this.$message.error("获取年级信息失败，请稍后再试");
        });
    },
    gradeChange(e) {
      if (e == "") {
        this.classList = [];
      } else {
        this.classList = this.gradeList.find(
          (item) => item.gradeId == e
        ).schoolClassList;
      }
      this.classId = "";
      this.gradeId = e;

      this.getStudentList();
    },
    classChange(e) {
      this.classId = e;
      this.getStudentList();
    },
    refresh() {
      // this.pageInfo = {
      //   pageSize: 10,
      //   pageNum: 1,
      // };
      // this.total = 0;
      this.classId = '';
      this.gradeId = '';
      this.sex = '';
      this.classList = [];
      // 获取学生列表
      this.getStudentList();
      this.selectStudentListByDorm();
    },
    // 学生退宿
    retreat(data) {
      this.$confirm("是否为该学生办理退宿?", "学生退宿", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除接口
          this.delete(this.$url.studentDormDelBind, {
            dormId: this.dormInfo.id,
            studentId: data.id,
          })
            .then((res) => {
              // console.log(res);
              if (res.code !== 200) {
                return this.$message.error(res.msg);
              }
              this.$message.success("退宿成功");
              // 刷新列表
              // 获取学生列表
              this.getStudentList();
              this.selectStudentListByDorm();
            })
            .catch((err) => {
              // this.$message.error("退宿失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
    getStudentList() {
      this.get(this.$url.getNotDormStudentList, {
        schoolId: this.user.schoolId,
        studentName: this.queryName,
        pageSize: this.pageInfo.pageSize,
        pageNum: this.pageInfo.pageNum,
        classId: this.classId,
        gradeId: this.gradeId,
        sex: this.sex
      }).then((res) => {
        // console.log("获取学校未入住学生==>", res);
        this.studentData = res.rows;
        this.total = res.total;
      });
    },
    // 获取宿舍内的学生信息
    selectStudentListByDorm() {
      this.post(this.$url.selectStudentListByDorm, {
        id: this.dormInfo.id,
      }).then((res) => {
        // console.log("获取宿舍内的学生信息==>", res);
        if (res.code == 200) {
          this.studentListByDorm = res.data;
          this.studentListByDormNum = res.data.length;
        }
      });
    },
    addStudentDorm(data) {
      this.post(this.$url.addStudentDorm, {
        dormId: this.dormInfo.id,
        studentIds: data,
      }).then((res) => {
        // console.log("学生入住宿舍==>", res);
        if (res.code != 200) {
          this.$refs.studentList.clearSelection();
          return this.$message.error(res.msg);
        }
        this.$message.success("学生入住成功");
        // 获取学生列表
        this.getStudentList();
        this.selectStudentListByDorm();
      });
    },
    search(studentName) {
      this.queryName = studentName;
      this.getStudentList();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getStudentList();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getStudentList();
    },
  },
};
</script>

<style scoped lang="scss">
@import "./studentDorm.scss";
</style>